// extracted by mini-css-extract-plugin
export default {"alertWrap":"style_alertWrap__0Z03d","alert":"style_alert__NJ9+f"};